import {
  DO_PAYMENT_POST,
  DO_PAYMENT_POST_SUCCESS,
  DO_PAYMENT_SIGN_VOID,
  DO_PAYMENT_SIGN_VOID_SUCCESS,
  DO_PAYMENT_SIGN_REFUND,
  DO_PAYMENT_SIGN_REFUND_SUCCESS,
  DO_PAYMENT_POST_API_ERROR
} from "./actionTypes"

export const doPaymentPost = record => ({
  type: DO_PAYMENT_POST,
  payload: record
})
export const doPaymentPostSuccess = record => ({
  type: DO_PAYMENT_POST_SUCCESS,
  payload: record
})
export const doPaymentSignVoid = record => ({
  type: DO_PAYMENT_SIGN_VOID,
  payload: record
})
export const doPaymentSignVoidSuccess = record => ({
  type: DO_PAYMENT_SIGN_VOID_SUCCESS,
  payload: record
})
export const doPaymentSignRefund = record => ({
  type: DO_PAYMENT_SIGN_REFUND,
  payload: record
})
export const doPaymentSignRefundSuccess = record => ({
  type: DO_PAYMENT_SIGN_REFUND_SUCCESS,
  payload: record
})
export const doPaymentApiError = error => {
  return {
    type: DO_PAYMENT_POST_API_ERROR,
    payload: error,
  }
}
